import React from 'react';

export default function AddFormButton({ onAdd, disabled = false }) {
  return (
    <button
      type="button"
      className="ca-add-form-button"
      onClick={onAdd}
      disabled={disabled}
    >
      + Add Form Fields
    </button>
  );
}